
















import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class JudgeTranslate extends Vue {
  @Prop() private question: any;
  private created() {}
  private formData: object = {
    answer: '',
  };
  private ruleValidate: object = {
    answer: [{ required: true, message: '请输入转写内容' }],
  };
  get questionData() {
    return JSON.parse(this.question);
  }
  private handleValidate() {
    let data;
    (this.$refs.formValidate as any).validate(valid => {
      if (valid) {
        data = { valid: valid, answer: (this.formData as any).answer };
      } else {
        data = false;
      }
    });
    return data;
  }
  private resetAnswer(answer) {
    (this.formData as any).answer = answer;
  }
}
